import { createRequest, RequestConfig } from 'app/common/api';

import { TEmployee } from '../core/employee';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/update_employee',
};

type UpdatedEmployee = Partial<TEmployee> & { id: number };

export const updateEmployeeRequest = (body: UpdatedEmployee) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
